import { Chip, type ChipProps } from '@mui/material';
import { useToggle } from '../../../hooks/use-toggle';

type ToggleChipProps = {
  defaultColor?: string;
  defaultContrastColor?: string;
  toggledColor?: string;
  toggledContrastColor?: string;
  initialToggle?: boolean;
  onToggle?: (isToggle: boolean) => void;
} & ChipProps;

export const ToggleChip: React.FC<ToggleChipProps> = ({
  onToggle,
  initialToggle = false,
  defaultColor,
  toggledColor,
  defaultContrastColor,
  toggledContrastColor,
  clickable = true,
  ...restOfProps
}) => {
  const [isToggle, toggle] = useToggle(initialToggle);

  const handleClick = () => {
    toggle((value) => onToggle?.(value));
  };

  return (
    <Chip
      onClick={handleClick}
      clickable={clickable}
      {...restOfProps}
      sx={{
        backgroundColor: isToggle ? toggledColor : defaultColor,
        color: isToggle ? toggledContrastColor : defaultContrastColor,
        '&:hover': {
          backgroundColor: isToggle ? toggledColor : defaultColor,
          filter: 'brightness(120%)',
        },
        '&:active': {
          boxShadow: 'none',
          backgroundColor: isToggle ? toggledColor : defaultColor,
          borderColor: isToggle ? toggledColor : defaultColor,
        },
        '&.MuiChip-root .MuiTouchRipple-root': {
          display: 'none',
        },
        ...restOfProps.sx,
      }}
    />
  );
};
